import SurveyPatients from './SurveyPatients.jsx';

export default SurveyPatients;